import axios from 'axios'
import store from '../store'

const baseUrl = () => store.state.parantion.baseUrl

export function setHeaders (token, db) {
  axios.defaults.headers.common['X-CSRFToken'] = token
  axios.defaults.headers.common['X-Database'] = db
}

export async function getTasks () {
  return (await axios.get(baseUrl() + '/v51/task')).data.tasks
}

export async function getFormFields (fhList, uh) {
  const tasks = (await axios.get(baseUrl() + `/v51/form`, { params: { 'fh': fhList } })).data.form
  const progresses = (await getFormProgress(uh)).data.user

  tasks.forEach(task => {
    let progress = progresses.find(progress => task.fh === progress.fh)
    if (progress) task.field.progress = progress.frm_progress[0].name
  })
  return tasks.map(task => task.field)
}

export async function getFormProgress (uh) {
  return axios.get(baseUrl() + `/v51/form/all/user`, {
    params: {
      uh
    }
  })
}

export function unsubscribeAccount (uh, email, reason, group, mail_user_subject, mail_user_message, mail_action_subject, mail_action_message) {
  return axios.delete(baseUrl() + '/v51/account/register', {
    data: { uh, email, reason, group, mail_user_message, mail_user_subject, mail_action_subject, mail_action_message, group_remove_all: 1 }
  })
}

export async function getPipConfigDirectus (directusUrl, oid) {
  return (await (await fetch(`${directusUrl}/items/pip_configs?filter[oid][_eq]=${oid}`)).json()).data[0]
}

export async function getFileFromDirectus (directusUrl, id) {
  return directusUrl + '/assets/' + id
}
